 import Http from '../../common/services/Http';
import { Paged } from '../common/types/Page';
 import { RoleSearchCriteria } from './models/RoleSearchCriteria';
 import { RoleDto } from './models/RoleDto';

class RoleService {

   
    public getList(criteria: RoleSearchCriteria) {
        return Http.get<Paged<RoleDto>>('roles', criteria);
    }

    public getById(id: string,companyId?:string) {
        return Http.get<RoleDto>('roles/' + id,{ companyId });
    }
  
    public create(model: RoleDto) {
        return Http.post('roles', model);
    }

    public update(model: RoleDto) {
        return Http.put('roles', model);
    }

    public remove(model: RoleDto) {
        return Http.put('roles/deactivate', model);
    }
    
    public getAllForCompany(id?:string) {
        return Http.get<RoleDto[]>('roles/all',{ companyId:id });
    }

   public syncAdminRoles() {
        return Http.put('roles/sync-admin-roles', undefined);
    }
}

export default new RoleService();